import React, {Component} from "react";
import {connect} from "react-redux";
import Loading from "./Loading";
import IFrame from "./IFrame";
import {setTracker, toggleTracker} from "../redux/actions/tracker";

class Tracker extends Component {
	closeTracker() {
		this.props.onSetTracker(null);
	}

	render() {
		const {trackerId, isOpen} = this.props.tracker;

		if ( trackerId === null ) {
			return <div></div>;
		}

		return (
			<div className={`tracker ${isOpen && 'show'}`}>
				<div className="tracker__header">
					<span>Онлайн-матч</span>
					<div className="tracker__header__buttons">
						<span onClick={this.closeTracker.bind(this)}><i className="fas fa-times"></i></span>
					</div>
				</div>
				<div className="tracker__data">
					<IFrame src={`https://tracker.maxline.by/app#live:${trackerId}`}/>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		tracker : state.tracker
	}),
	dispatch => ({
		onSetTracker    : (trackerId) => {
			dispatch(setTracker(trackerId));
		},
	})
)(Tracker);


// WEBPACK FOOTER //
// ./src/app/components/Tracker.js